import React, { FC } from 'react'

import { IconPriceTagProps } from './IconPriceTag.types'
import * as Styled from './styles/IconPriceTag.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPriceTag: FC<IconPriceTagProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPriceTagProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPriceTagProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M158.66 1.5a4 4 0 0 0-5.66 0l-15.81 15.81A11.91 11.91 0 0 0 131.8 16H82a11.93 11.93 0 0 0-8.48 3.51L6.64 86.33a12 12 0 0 0 0 17l49.83 49.83a12 12 0 0 0 17 0l66.84-66.84a11.92 11.92 0 0 0 3.52-8.46V28a11.91 11.91 0 0 0-1.07-4.93l15.9-15.91a4 4 0 0 0 0-5.66zM135.8 77.81a4 4 0 0 1-1.18 2.82l-66.84 66.84a4 4 0 0 1-5.65 0L12.3 97.64a4 4 0 0 1 0-5.65l66.87-66.82A4 4 0 0 1 82 24h48.49L120.1 34.41a15.8 15.8 0 1 0 5.66 5.66l10-10zM119.92 48a7.79 7.79 0 1 1-5.92-7.52l-4.69 4.69a4 4 0 0 0 5.69 5.66l4.69-4.69a7.72 7.72 0 0 1 .23 1.86z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPriceTag
